var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebTransparencyIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5848:33329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.051 16.9182L15.5234 18.9229L7.5061 32.8104L4.03367 30.8058L12.051 16.9182Z",
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2617 19.5599C15.4463 20.8501 10.4967 17.9924 9.20653 13.1769C7.91633 8.36151 10.7741 3.41196 15.5895 2.12175C20.4049 0.831551 25.3545 3.68929 26.6447 8.50473C27.9349 13.3202 25.0772 18.2697 20.2617 19.5599Z",
    stroke: "#C1C7D0",
    strokeWidth: 0.99588,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5848:33329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 32 0.805664)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebTransparencyIcn);
export default __webpack_public_path__ + "static/media/Web Transparency Icn.11ff0288.svg";
export { ForwardRef as ReactComponent };